import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capitalizeFirstWord',
})
export class CapitalizeFirstWordPipe implements PipeTransform {
  transform(value: any): string {
    if (!value) return value;
    const words = value.split(' ');
    if (words.length > 0) {
      words[0] = words[0].charAt(0).toUpperCase() + words[0].slice(1);
    }
    return words.join(' ');
  }
}
